"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteInvoiceChangeEventMutation = exports.useFetchInvoiceAuditLogQuery = exports.useFetchInvoiceHistoryQuery = exports.useRemoveTenantInvoiceMutation = exports.useFetchInvoiceTypesByBuildingQuery = exports.useFetchTenantInvoicesByTenantQuery = exports.useFetchTenantInvoicesByOccupancyQuery = exports.useSaveTenantInvoicesMutation = exports.tenantInvoiceApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.tenantInvoiceApi = (0, react_1.createApi)({
    reducerPath: "tenantInvoiceApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["tenantInvoices"],
    endpoints: function (builder) { return ({
        saveTenantInvoices: builder.mutation({
            query: function (body) { return ({
                url: "/v1/tenant-invoice/save-batch",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["tenantInvoices"],
        }),
        fetchTenantInvoicesByOccupancy: builder.query({
            query: function (occupancyId) { return ({
                url: "/v1/tenant-invoice/by-occupancy",
                method: "GET",
                params: { occupancyId: occupancyId },
            }); },
            providesTags: ["tenantInvoices"],
        }),
        fetchTenantInvoicesByTenant: builder.query({
            query: function (tenantId) { return ({
                url: "/v1/tenant-invoice/by-tenant",
                method: "GET",
                params: { tenantId: tenantId },
            }); },
            providesTags: ["tenantInvoices"],
        }),
        fetchInvoiceTypesByBuilding: builder.query({
            query: function (_a) {
                var clientId = _a.clientId, buildingId = _a.buildingId;
                return ({
                    url: "/v1/tenant-invoice/types-by-building",
                    method: "GET",
                    params: { clientId: clientId, buildingId: buildingId },
                });
            },
            providesTags: ["tenantInvoices"],
        }),
        removeTenantInvoice: builder.mutation({
            query: function (_a) {
                var _id = _a._id, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/tenant-invoice/remove",
                    method: "DELETE",
                    params: __assign({ _id: _id, performedBy: performedBy }, (reason ? { reason: reason } : {})),
                });
            },
            invalidatesTags: ["tenantInvoices"],
        }),
        fetchInvoiceHistory: builder.query({
            query: function (invoiceId) { return ({
                url: "/v1/tenant-invoice/history",
                method: "GET",
                params: { _id: invoiceId },
            }); },
            providesTags: function (_result, _err, invoiceId) { return [{ type: "tenantInvoices", id: "history:".concat(invoiceId) }]; },
        }),
        fetchInvoiceAuditLog: builder.query({
            query: function (_a) {
                var invoiceId = _a.invoiceId, action = _a.action, includeDeleted = _a.includeDeleted;
                return ({
                    url: "/v1/tenant-invoice/audit-log",
                    method: "GET",
                    params: __assign(__assign({ _id: invoiceId }, (action ? { action: action } : {})), (includeDeleted ? { includeDeleted: true } : {})),
                });
            },
            providesTags: function (_result, _err, arg) { return [{ type: "tenantInvoices", id: "audit:".concat(arg.invoiceId) }]; },
        }),
        deleteInvoiceChangeEvent: builder.mutation({
            query: function (_a) {
                var eventId = _a.eventId, performedBy = _a.performedBy, reason = _a.reason;
                return ({
                    url: "/v1/tenant-invoice/audit-log/event",
                    method: "DELETE",
                    body: { eventId: eventId, performedBy: performedBy, reason: reason },
                });
            },
            invalidatesTags: function (_result, _err, arg) { return [
                { type: "tenantInvoices", id: "audit:".concat(arg.invoiceId) },
                { type: "tenantInvoices", id: "history:".concat(arg.invoiceId) },
            ]; },
        }),
    }); },
});
exports.useSaveTenantInvoicesMutation = exports.tenantInvoiceApi.useSaveTenantInvoicesMutation, exports.useFetchTenantInvoicesByOccupancyQuery = exports.tenantInvoiceApi.useFetchTenantInvoicesByOccupancyQuery, exports.useFetchTenantInvoicesByTenantQuery = exports.tenantInvoiceApi.useFetchTenantInvoicesByTenantQuery, exports.useFetchInvoiceTypesByBuildingQuery = exports.tenantInvoiceApi.useFetchInvoiceTypesByBuildingQuery, exports.useRemoveTenantInvoiceMutation = exports.tenantInvoiceApi.useRemoveTenantInvoiceMutation, exports.useFetchInvoiceHistoryQuery = exports.tenantInvoiceApi.useFetchInvoiceHistoryQuery, exports.useFetchInvoiceAuditLogQuery = exports.tenantInvoiceApi.useFetchInvoiceAuditLogQuery, exports.useDeleteInvoiceChangeEventMutation = exports.tenantInvoiceApi.useDeleteInvoiceChangeEventMutation;
